import { render, staticRenderFns } from "./Pasta.vue?vue&type=template&id=323782ff"
import script from "./Pasta.vue?vue&type=script&lang=js"
export * from "./Pasta.vue?vue&type=script&lang=js"
import style0 from "./Pasta.vue?vue&type=style&index=0&id=323782ff&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports